import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=af3f4220&scoped=true&"
import script from "./countDown.vue?vue&type=script&lang=ts&"
export * from "./countDown.vue?vue&type=script&lang=ts&"
import style0 from "./countDown.vue?vue&type=style&index=0&id=af3f4220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3f4220",
  null
  
)

export default component.exports